import React from 'react';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { startCase, values, flatMap } from 'lodash';

// core components
import { makeStyles } from '@material-ui/core';

import PickerSelect from 'components/Staffing/PickerSelect/PickerSelect';

import { setDealsFilterPayload } from 'redux/actions/staffingActions';
import {
  PROJECT_STATUS_STATES,
  PROJECT_ERROR_STATUS_STATES,
  PROJECT_SERVICE_SELECT_OPTIONS,
  PROJECT_LOCATION_TYPES_SELECT_OPTIONS,
} from 'constants/staffing';

import './projectsFilter.scss';
import {
  selectProjectMethodologies,
  projectFiltersDerivedSelectOptions,
} from 'redux/selectors/staffing/getProject';
import { selectCompanies } from 'redux/selectors/staffing/getDeals';
import SearchableSelectProjectFilter from '../SearchableSelectProjectFilter';
import { selectConfigSelectOptions } from 'redux/selectors/staffing/getConfig';

// useStyles
const useStyles = makeStyles(theme => ({
  main: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 25,
    gap: '0 15px',
  },
  formControl: {
    margin: theme.spacing(1),
    marginRight: -5,
    flexGrow: 1,
  },
  input: {
    width: 143,
    backgroundColor: '#EEEEEE',
  },
  inputLabel: {
    paddingLeft: 10,
    zIndex: 2,
  },
  select: {
    '& .MuiSelect-select': {
      paddingLeft: theme.spacing(1), // Adds left padding to the selected value
    },
  },
  pickerSelect: {
    minWidth: 200, // Increase this value as needed
    '& .MuiInputBase-root': {
      width: '100%',
    },
  },
}));

const ProjectsFilter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  //Get the Project Methodologies from the Store
  const getAllProjectMethodologies = selectProjectMethodologies();
  const getConfig = selectConfigSelectOptions();
  const { selectOptions: venues } = useSelector(state => getConfig(state, 'vcEventVenues'));
  const { projectMethodologies } = useSelector(state => getAllProjectMethodologies(state));

  const handleSelect = (value, filterParam) => {
    dispatch(
      setDealsFilterPayload({
        [filterParam]: value,
      }),
    );
  };

  const PROJECT_STATUS_OPTIONS = flatMap(
    [PROJECT_STATUS_STATES, PROJECT_ERROR_STATUS_STATES],
    values,
  ).map(value => ({
    value,
    name: startCase(value),
  }));

  const { companies } = useSelector(selectCompanies());

  return (
    <div className={cx(classes.main)}>
      <PickerSelect
        label="Status"
        classNames={`deals-filter-select-input ${classes.select} ${classes.pickerSelect}`}
        options={PROJECT_STATUS_OPTIONS}
        onChange={value => {
          handleSelect(value, 'projectsStatus');
        }}
      />

      <PickerSelect
        label="Methodology"
        classNames={`deals-filter-select-input ${classes.select} ${classes.pickerSelect}`}
        options={projectMethodologies}
        onChange={value => {
          handleSelect(value, 'projectMethodology');
        }}
      />
      <PickerSelect
        label="Service Type"
        classNames={`deals-filter-select-input ${classes.select} ${classes.pickerSelect}`}
        options={PROJECT_SERVICE_SELECT_OPTIONS}
        onChange={value => {
          handleSelect(value, 'projectServiceType');
        }}
      />
      <PickerSelect
        label="Location Type"
        classNames={`deals-filter-select-input ${classes.select} ${classes.pickerSelect}`}
        options={PROJECT_LOCATION_TYPES_SELECT_OPTIONS}
        onChange={value => {
          handleSelect(value, 'projectLocationType');
        }}
      />
      <SearchableSelectProjectFilter
        classNames={`deals-filter-select-input ${classes.select} ${classes.pickerSelect}`}
        options={venues}
        label="Venue"
        onChange={(event, option) => {
          handleSelect(option, 'projectVenue');
        }}
      />

      <SearchableSelectProjectFilter
        classNames={`deals-filter-select-input ${classes.select} ${classes.pickerSelect}`}
        options={companies}
        label="Company"
        onChange={(event, option) => {
          handleSelect(option, 'projectCompanyId');
        }}
      />
    </div>
  );
};

export default ProjectsFilter;
